import dayjs from 'dayjs';
import { DateUnit } from '../types';

/** Gets the start and end date range for a given date. */
export const getStartAndEnd = (date: dayjs.Dayjs, unit: DateUnit) => ({
  start: date.startOf(unit).toDate(),
  end: date.endOf(unit).toDate(),
});
